import { render, staticRenderFns } from "./GamingArt.vue?vue&type=template&id=5d81c1d0"
import script from "./GamingArt.vue?vue&type=script&lang=js"
export * from "./GamingArt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports